export default __webpack_public_path__ + "static/media/GooglePlay.405b591d.svg";